/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  FileUploadDocumentResponseData,
  FileUploadDocumentResponseDataFromJSON,
  FileUploadDocumentResponseDataFromJSONTyped,
  FileUploadDocumentResponseDataToJSON
} from './FileUploadDocumentResponseData'

/**
 *
 * @export
 * @interface FileUploadDocumentResponse
 */
export interface FileUploadDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof FileUploadDocumentResponse
   */
  status: number
  /**
   *
   * @type {FileUploadDocumentResponseData}
   * @memberof FileUploadDocumentResponse
   */
  data: FileUploadDocumentResponseData
}

export function FileUploadDocumentResponseFromJSON(json: any): FileUploadDocumentResponse {
  return FileUploadDocumentResponseFromJSONTyped(json, false)
}

export function FileUploadDocumentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FileUploadDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: json['status'],
    data: FileUploadDocumentResponseDataFromJSON(json['data'])
  }
}

export function FileUploadDocumentResponseToJSON(value?: FileUploadDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: FileUploadDocumentResponseDataToJSON(value.data)
  }
}
